import React, {useEffect, useState} from "react";
import css from './footerHelpFloor.module.scss'
import classNames from "classnames";
import {observer} from "mobx-react";
import {makeAutoObservable} from "mobx";
import QrCodeEnum from "enum/QrCodeEnum";
import * as Api from 'api/api'
import useMyStores from "@/hooks/useMyStores";
import Router from "@/router/router";
import {useHistory} from "react-router-dom";


class QrCodeStore {

    list = []

    setList(value) {
        this.list = value
    }

    get webQrCode() {
        return this.list.find(item => item.type === QrCodeEnum.WEB_QR_CODE.value)
    }

    get miniQrCOde() {
        return this.list.find(item => item.type === QrCodeEnum.MINI_APP_QR_CODE.value)
    }

    get appQrCOde() {
        return this.list.find(item => item.type === QrCodeEnum.APP_QR_CODE.value)
    }

    async fetchList() {
        const data = await Api.qrCodeList()
        this.list = data.list
    }

    constructor() {
        makeAutoObservable(this)
    }
}

const qrCodeStore = new QrCodeStore()

function useFetchQrCode() {
    useEffect(() => {
        qrCodeStore.fetchList().then()
    }, []);
}

class Help {

    history = undefined

    constructor({history}) {
        this.history = history;
    }

    list = [

        {
            title: "购物指南",
            level: 1,
            onClick: () => {
                this.history.push({
                    pathname: "/help",
                    search: `categoryId=2`,
                })
            },
            children: [
                {
                    title: "购物流程",
                    level: 2,
                    onClick: () => {
                        this.history.push({
                            pathname: "/help",
                            search: `categoryId=2&articleId=33`,
                        })
                    },
                },
                {
                    title: "交易条款",
                    level: 2,
                    onClick: () => {
                        this.history.push({
                            pathname: "/help",
                            search: `categoryId=2&articleId=22`,
                        })
                    },
                },
                {
                    title: "用户协议",
                    level: 2,
                    onClick: () => {
                        this.history.push({
                            pathname: "/help",
                            search: `categoryId=2&articleId=23`,
                        })
                    },
                },
            ]
        },
        {
            title: "配送方式",
            level: 1,
            onClick: () => {
                this.history.push({
                    pathname: "/help",
                    search: `categoryId=3`,
                })
            },
            children: [
                {
                    title: "上门自提",
                    level: 2,
                    onClick: () => {
                        this.history.push({
                            pathname: "/help",
                            search: `categoryId=3&articleId=26`,
                        })
                    },
                },
                {
                    title: "发货与签收规范",
                    level: 2,
                    onClick: () => {
                        this.history.push({
                            pathname: "/help",
                            search: `categoryId=3&articleId=25`,
                        })
                    },
                },
                {
                    title: "第三方配送服务说明",
                    level: 2,
                    onClick: () => {
                        this.history.push({
                            pathname: "/help",
                            search: `categoryId=3&articleId=24`,
                        })
                    },
                },
            ]
        },
        {
            title: "支付方式",
            level: 1,
            onClick: () => {
                this.history.push({
                    pathname: "/help",
                    search: `categoryId=4`,
                })
            },
            children: [
                {
                    title: "货到付款",
                    level: 2,
                    onClick: () => {
                        this.history.push({
                            pathname: "/help",
                            search: `categoryId=4&articleId=27`,
                        })
                    },
                },
                {
                    title: "在线支付",
                    level: 2,
                    onClick: () => {
                        this.history.push({
                            pathname: "/help",
                            search: `categoryId=4&articleId=28`,
                        })
                    },
                },
                {
                    title: "支付错误",
                    level: 2,
                    onClick: () => {
                        this.history.push({
                            pathname: "/help",
                            search: `categoryId=4&articleId=29`,
                        })
                    },
                },
            ]
        },
        {
            title: "售后服务",
            level: 1,
            onClick: () => {
                this.history.push({
                    pathname: "/help",
                    search: `categoryId=5`,
                })
            },
            children: [
                {
                    title: "服务承诺",
                    level: 2,
                    onClick: () => {
                        this.history.push({
                            pathname: "/help",
                            search: `categoryId=5&articleId=30`,
                        })
                    },
                },
                {
                    title: "退款说明",
                    level: 2,
                    onClick: () => {
                        this.history.push({
                            pathname: "/help",
                            search: `categoryId=5&articleId=32`,
                        })
                    },
                },
                {
                    title: "服务总则",
                    level: 2,
                    onClick: () => {
                        this.history.push({
                            pathname: "/help",
                            search: `categoryId=5&articleId=31`,
                        })
                    },
                },
            ]
        },
        {
            title: "会员中心",
            level: 1,
            children: [
                {
                    title: "浏览记录",
                    level: 2,
                    onClick: () => {
                        window.open(
                            Router.basename + Router.User.path + "?currentIndex=4"
                        );

                    },
                },
                {
                    title: "我的收藏",
                    level: 2,
                    onClick: () => {
                        window.open(
                            Router.basename + Router.User.path + "?currentIndex=2"
                        );
                    },
                },
                {
                    title: "帮助中心",
                    level: 2,
                    onClick: () => {
                        this.history.push({
                            pathname: "/help",
                        })
                    },
                },
            ]
        },
    ]
}

const Index = ({className}) => {

    const {app: appStore} = useMyStores()
    const history = useHistory()

    const help = new Help({history})


    useFetchQrCode()

    return (
        <div className={classNames(className, css.root)}>
            <div className={css.container}>
                {/* 帮助中心链接 */}
                <div className={css.helpList}>
                    {
                        help?.list.map((help, i) => {
                            const {title, onClick, children, needWindow} = help;

                            return (
                                <div key={i} className={css.helpBlock} onClick={onClick}>
                                    <div className={css.helpWrapper}>
                                        <div className={css.title}>
                                            {title}
                                        </div>
                                    </div>
                                    <div className={css.children}>
                                        {
                                            children.map((child, j) => {
                                                const {title: childTitle, onClick} = child;
                                                return (
                                                    <div key={j} className={css.childWrapper} onClick={onClick}>
                                                        {childTitle}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                {/* 二维码 */}
                <div className={css.qrCodeBlock}>
                    <div className={css.qrCodeList}>
                        {
                            qrCodeStore.webQrCode?.img &&
                            <div className={css.qrCodeWrapper}>
                                <img src={qrCodeStore.webQrCode?.img} alt="" className={css.qrCode}/>
                                <div className={css.titleWrapper}>
                                    <div className={css.title}>{appStore.app?.websiteName}</div>
                                    {/*<img src={require('./img/二维码文字底部背景.png')} className={css.bgImg}/>*/}
                                </div>
                            </div>
                        }
                        {
                            qrCodeStore.miniQrCOde?.img &&
                            <div className={css.qrCodeWrapper}>
                                <img src={qrCodeStore.miniQrCOde?.img} alt="" className={css.qrCode}/>
                                <div
                                    className={css.titleWrapper}
                                    style={{
                                        paddingBottom: 7
                                    }}
                                >
                                    <div className={css.title}>{appStore.app?.miniName}</div>
                                    <div className={css.title}>{appStore.app?.minioNameSuffix}</div>
                                </div>
                            </div>

                        }
                        {
                            qrCodeStore.appQrCOde?.img &&
                            <div className={css.qrCodeWrapper}>
                                <img src={qrCodeStore.appQrCOde?.img} alt="" className={css.qrCode}/>
                                <div
                                    className={css.titleWrapper}
                                    style={{
                                        paddingBottom: 7
                                    }}
                                >
                                    <div className={css.title}>{appStore.app?.appName}</div>
                                    <div className={css.title}>{appStore.app?.appNameSuffix}</div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(Index)